import type { ModelResultType } from "../../../shared-logic/features/filters/utils/constants/resultConstants";
import type { TradeInAemModelSelectType } from "../../utils/constants";

export const TRADE_IN_AEM_MODEL_SELECT_SET_ENABLED = "tradeInAemModelSelect/setEnabled";
export type TradeInAemModelSelectSetEnabled = {
    type: typeof TRADE_IN_AEM_MODEL_SELECT_SET_ENABLED;
    enabled: boolean;
};
export const tradeInAemModelSelectSetEnabled = (enabled: boolean): TradeInAemModelSelectSetEnabled => ({
    type: TRADE_IN_AEM_MODEL_SELECT_SET_ENABLED,
    enabled,
});

export const TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_LIST = "tradeInAemModelSelect/setModelList";
export type TradeInAemModelSelectSetModelList = {
    type: typeof TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_LIST;
    modelList: ModelResultType[];
};
export const tradeInAemModelSelectSetModelList = (carList: ModelResultType[]): TradeInAemModelSelectSetModelList => ({
    type: TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_LIST,
    modelList: carList,
});

export const TRADE_IN_AEM_MODEL_SELECT_SELECT_CAR_TYPE = "tradeInAemModelSelect/selectCarType";
export type TradeInAemModelSelectSelectCarType = {
    type: typeof TRADE_IN_AEM_MODEL_SELECT_SELECT_CAR_TYPE;
    carType: TradeInAemModelSelectType | null;
};
export const tradeInAemModelSelectSelectCarType = (
    carType: TradeInAemModelSelectType | null,
): TradeInAemModelSelectSelectCarType => ({
    type: TRADE_IN_AEM_MODEL_SELECT_SELECT_CAR_TYPE,
    carType,
});

export const TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_ID = "tradeInAemModelSelect/setModelId";
export type TradeInAemModelSelectSetModelId = {
    type: typeof TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_ID;
    modelId: string;
};
export const tradeInAemModelSelectSetModelId = (modelId: string): TradeInAemModelSelectSetModelId => ({
    type: TRADE_IN_AEM_MODEL_SELECT_SET_MODEL_ID,
    modelId,
});

export type TradeInAemModelSelectActions =
    | TradeInAemModelSelectSetEnabled
    | TradeInAemModelSelectSetModelList
    | TradeInAemModelSelectSelectCarType
    | TradeInAemModelSelectSetModelId;
